import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './Technology.css';
import imageChina from './assets/images/shutterstock_102001114-scaled-e1595525157473.jpg';
import abt_first from './assets/images/shutterstock_1135913807-1-scaled.jpg';
import abt_first1 from './assets/images/AdobeStock_298257725-1-scaled.jpeg';

import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';


const Technology = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "Technology – Bay Capital Advisors";
    
    // Find and update the favicon
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.href = logo; // Use your logo as favicon
    
    return () => {
      // Reset title when component unmounts if needed
      document.title = "Bay Capital Advisors";
    };
  }, []);
          
            const toggleMobileMenu = () => {
              setIsMobileMenuOpen(!isMobileMenuOpen);
            };
          
            const closeMobileMenu = () => {
              setIsMobileMenuOpen(false);
            };
  return (
    <div className="technology-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
        <section class="hero5">
    
        <div class="blue-overlay"></div>
    
    <header class="header5">
    
    <NavBar />
  </header>
        <header className="technology-header">
            <div className="technology-header-overlay">
            <h1>TECHNOLOGY & IT SERVICES</h1>
            </div>
        </header>
        </section>
        {/* First Section */}
      <div className="technology-section">
        <div className="tech-column title-text">
          <h2>Enhanced Value in IT Services Through Strategic Combinations and Growth Financings</h2>
        </div>
        <div className="tech-column center-image">
          <img src={imageChina} alt="Data Center" />
        </div>
        <div className="tech-column description-text">
          <p>
          One of the areas of core focus for Bay Capital Advisors® is specializing in mergers and acquisitions, financings, and strategic joint ventures for the information technology (IT) industry.  Since 2002, our team of experienced bankers and former technology company executives has created additional new wealth for our clients.  We are dedicated to strategic M&A advisory services that achieve greater shareholder value for companies that operate in the IT Services sector.
          </p>
        </div>
      </div>
      <div className="technology-content1">
    <div className="technology-text-column12">
        <p>
            Bay Capital Advisors advises companies across a broad spectrum of IT sectors, including application and infrastructure software, devops, and IT services, as well as specializing in markets such as financial and government technology and IT security.
        </p>
    </div>

    <div className="technology-image1">
        <img src={abt_first} alt="China Focus" />
    </div>
</div>


      {/* Blue Background Section with Overlay */}
      <div className="blue-background-section">
        <p>
        We fully comprehend the unique corporate, financial, legal and personal dimensions of every transaction. In addition, we understand the technologies our clients produce and maintain extensive ongoing research to stay current in this dynamic landscape.  Our backgrounds as technology executives and experienced investment bankers, our exclusive focus on advisory services to high growth companies in the information technology industry and our passion for what we do enable us to create greater outcomes for our clients.  Our expertise encompasses a range of advisory services, including:
        </p>
        <ul>
          <li>Mergers & Acquisitions</li>
          <li>Debt Finance and Asset Based Lending</li>
          <li>Fairness Opinions and Valuations</li>
          <li>Strategic Private Placements</li>
          <li>Management Buyouts</li>
          <li>Roll-Ups</li>
          <li>Recapitalizations</li>
          <li>Divestitures</li>
        </ul>
      </div>

      {/* Final Content Section */}
      <div className="final-content-section">
        <div className="tech-column final">
          <p>
          Our team comprises former executives of software and IT services companies and experienced IT-focused investment bankers, enabling uniquely superior advisory capabilities for our clients.  Over the last 5 years, our professionals have completed a number of M&A transactions both as advisors to companies and as operators within them. 
          </p>
        </div>
        <div className="tech-column image-column">
          <img src={abt_first1} alt="Teamwork" />
        </div>
        <div className="tech-column final1">
          <p>
          We fully comprehend the corporate, financial, legal and personal dimensions of every transaction.  In addition, we understand how and where our clients’ technologies create value in the information technology industry.  We maintain extensive ongoing research to stay current on the marketplace and technological trends.
          </p>
        </div>
      </div>

      {/* Footer Section */}
      

      <div className="concluding-section-div8">
        <section className="concluding-section8">
            <p>Whether you are an acquirer or a seller, a mutual understanding and collective effort with your investment banker is the most crucial element of success in this sensitive and highly confidential relationship. By partnering with Bay Capital Advisors, you will receive a level of personal attention and expertise unmatched by any other investment banking firm, large or small.
            </p>
        </section>
      </div>
      {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
        <Link to="/"> {/* Add this Link wrapper */}
          <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
        </Link>
        </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>

    </div>
  );
};

export default Technology;